var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackArrowCyan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.110848 256C0.110836 397.324 114.676 511.889 256 511.889C397.324 511.889 511.889 397.324 511.889 256C511.889 114.676 397.324 0.110921 256 0.110909C114.676 0.110897 0.11086 114.676 0.110848 256Z",
    fill: "#109e9e"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.142 59.7831L411.033 218.674C424.309 231.95 424.309 253.67 411.033 266.946C397.757 280.221 376.038 280.221 362.762 266.946L286.272 190.456L286.272 418.981C286.272 437.756 270.914 453.114 252.14 453.114C233.365 453.114 218.007 437.756 218.007 418.981L218.007 190.46L141.52 266.948C128.244 280.223 106.524 280.223 93.2485 266.948C79.9728 253.672 79.9728 231.952 93.2485 218.676L203.871 108.054L252.142 59.7831Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(512 512) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackArrowCyan);
export default __webpack_public_path__ + "static/media/track-arrow-cyan.16a1d1710cf280b6e3aaa638b2f5ac05.svg";
export { ForwardRef as ReactComponent };